import { GlobalActions, GlobalActionsEnum } from '../types/globalTypes';

const resetStore = (): GlobalActions => ({
  type: GlobalActionsEnum.RESET_STORE,
});

export default {
  resetStore,
};
